module.exports = __webpack_public_path__ + "img/bte.393b9721.png";